
import React from 'react';
import PropTypes from 'prop-types';
import {List, Map} from 'immutable';
import LoadingIndicator from 'client/generic/LoadingIndicator.react';
import BestTopicsStore from '../BestTopics/BestTopics.store';
import ToughestTopicsStore from '../ToughestTopics/ToughestTopics.store';
import {GuideLevelModelV2} from 'resources/augmented/GuideLevel/GuideLevelModel.v2';
import MasteryFlag from 'generic/MasteryFlag/MasteryFlag.react';
import makeRef from 'lib/makeRef';
import Tooltip from 'generic/FixedTooltip/FixedTooltip.react';
import createLocalStore from 'lib/decorators/createLocalStore';
import {stats} from 'lib/StatsUtil';
import '../topic-listing.scss';


const maxTopicNumber = 3;
export default class Topics extends React.Component {
  static propTypes = {
    topicStore: PropTypes.oneOfType([
      PropTypes.instanceOf(BestTopicsStore),
      PropTypes.instanceOf(ToughestTopicsStore)
    ]).isRequired,
    heading: PropTypes.string.isRequired
  };

  getTopicList() {
    const topicSize = this.props.topicStore.getTopics().size;

    let placeHolders = new List();
    for (let i = 0; i < (maxTopicNumber - topicSize); i++) {
      placeHolders = placeHolders.push(
        (
          <div className='topic-list-row'>
            <div className='topic-list-row__name topic-list-row__name--no-data topic-list-row-item'>No Data Available</div>
            <div className='topic-list-row__accuracy topic-list-row__accuracy--no-data topic-list-row-item'>N/A</div>
            <div className='topic-list-row__mastery topic-list-row__mastery--no-data topic-list-row-item'>N/A</div>
          </div>
        )
      );
    }

    // {placeHolders} ensures we always have at least 3 things in our card
    return (
      <div className='topic-list'>
        {this.props.topicStore.getTopics().map((topic, key) => {
          const accuracy = stats.toFixed(topic.getMetaStudentAccuracy());
          const storeName = `${this.props.topicStore.getName()}-${topic.getId()}`;
          return (
            <TopicItem
              key={topic.getId()}
              topic={topic}
              accuracy={accuracy}
              storeName={storeName}
            />
          );
        })}
        {placeHolders}
      </div>
    );
  }

  getEmptyTopicList() {
    return (
      <div className='topic-list topic-list--empty'>
        <div className='topic-list__empty-message'>
          No data available
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.topicStore.hasReceivedTopics()) {
      return <LoadingIndicator />;
    }

    return (
      <div>
        <h4 className='topic-list-heading'>{this.props.heading}</h4>
        {this.props.topicStore.getTopics().isEmpty() ? this.getEmptyTopicList() : this.getTopicList()}
      </div>
    );
  }
}

@createLocalStore(new Map({
  isOverflowing: false
}))
class TopicItem extends React.Component {
  static propTypes = {
    topic: PropTypes.instanceOf(GuideLevelModelV2).isRequired,
    accuracy: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.makeRef = makeRef.bind(this);
    this.refName = `${this.props.storeName}-name-ref`;
  }

  componentDidMount() {
    const ref = this[this.refName];
    const refParent = ref.parentElement;
    const isOverflowing = ref.clientWidth > refParent.clientWidth;

    if (isOverflowing) {
      this.setIsOverflowing();
    }
  }

  setIsOverflowing = () => {
    this.props.setProperty('isOverflowing', true);
  };

  render() {
    const isOverflowing = this.props.store.get('isOverflowing'); // read from store for element name

    let tooltip;
    if (isOverflowing) {
      tooltip = (
        <Tooltip type='white' >
          {this.props.topic.getName()}
        </Tooltip>
      );
    }

    return (
      <div
        className='topic-list-row'
      >
        <div className='topic-list-row__name topic-list-row-item'>
          <div
            className='topic-list-row__name-actual'
            ref={this.makeRef}
            data-ref-name={this.refName}
          >
            {this.props.topic.getName()}
            {tooltip}
          </div>
        </div>
        <div className='topic-list-row__accuracy topic-list-row-item'>{this.props.accuracy}% accuracy</div>
        <div className='topic-list-row__mastery topic-list-row-item'>
          <MasteryFlag
            accuracy={this.props.accuracy}
            hasStarted={true}
          />
        </div>
      </div>
    );
  }
}
